<template>
  <div class="comps-cardc-item centerimage primary-bg"
    :style="'background-image: url(' + imgurl + ');'">
    <div class="back-content">
      <h2 class="to-3" @click="$emit('click')" v-if="title">{{title}}</h2>
      <h2 class="to-3" v-else>
        <span class="dis-bl ht-20 gray-bg mb-10"></span>
        <span class="dis-bl ht-20 gray-bg mb-10"></span>
        <span class="dis-bl ht-20 gray-bg"></span>
      </h2>
      <p class="to-2" v-if="industries">行业分类: {{industries}}</p>
      <p class="to-2" v-else>
        <span class="dis-bl ht-18 gray-bg mb-10 wi-180"></span>
      </p>
      <p class="to-2" v-if="areas">业务类型: {{areas}}</p>
      <p class="to-2" v-else>
        <span class="dis-bl ht-18 gray-bg wi-180"></span>
      </p>
      <div class="btn-posi">
        <a-button class="cardc-btn" @click="$emit('click')">查看详情</a-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    imgurl: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    industries: {
      type: String,
      default: ''
    },
    areas: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
    }
  }
}
</script>

<style lang="less" scoped>
  @import url('../../../utils/color.less');
  .comps-cardc-item {
    width: 100%;
    position: relative;
    .back-content {
      height: 310px;
      padding: 30px;
      background: @op-primary;
      h2 {
        height: 94px;
        margin: 0 0 30px;
        font-family: Georgia, 宋体;
        font-weight: bold;
        color: #FFF;
      }
      p {
        margin-bottom: 4px;
        color: #FFF;
        opacity: 0.7;
      }
    }
    .btn-posi {
      padding: 30px;
      position: absolute;
      left: 0;
      bottom: 0;
    }
    .cardc-btn {
      width: 120px;
      height: 40px;
      font-size: 16px;
      color: @primary;
      background: @support;
      border-color: @support;
      border-radius: 0;
      &:hover {
        background: #FFF;
        border-color: #FFF;
      }
      &:active {
        color: @primary;
        background: @support;
        border-color: @support;
      }
    }
  }
  .comps-cardc-item:hover {
    cursor: default;
    .back-content {
      h2 {
        color: @support;
        cursor: pointer;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/Models/comps/cardCases.vue